import { gql } from '@/core/shared/api';
import Vue from 'vue';

export default {
  strict: true,
  namespaced: true,
  state: () => ({
    newGame: {},
    presetId: null,
  }),
  actions: {
    async createGame ({ state, dispatch }) {
      const synthesisVrId = state.synthesisVrId || null;
      const { _imageBlob, _videoBlob, ...newGame } = state.newGame;
      const mutationName = state.presetId && !synthesisVrId ? 'createGameFromPreset' : 'storeGame';
      const varName = state.presetId && !synthesisVrId ? 'preset' : 'game';
      const query = `
        mutation ($game: GameInput) {
         game: ${mutationName} (${varName}: $game) {
            id
            title
          }
        }
      `;
      const variables = {
        game: {
          ...newGame,
          imageBlobFieldName: _imageBlob && _imageBlob.name,
          videoBlobFieldName: _videoBlob && _videoBlob.name,
        },
      };
      if (state.presetId) variables.game.id = state.presetId;
      const blobs = [_imageBlob, _videoBlob].filter(v => !!v);
      const { game } = await gql.requestWithBlobs(query, variables, blobs);
      return game;
    },
    async prefillWithPreset ({ state, dispatch, commit }, preset) {
      const query = `
            query ($id: ID) {
              preset: gamePreset (id: $id) {
                id
                title
                ageRating
                imageUrl
                videoUrl
                description
                difficulty
                organizationTags {
                  id
                  text
                }
                singleplayer
                multiplayer
                launchMethod
                arguments
                filePath
                uri
              }
            }
          `;
      const variables = {
        id: preset.id,
      };

      const { preset: newPreset } = await gql.request(query, variables);
      dispatch(
        'insertEntities',
        {
          name: 'Game',
          payload: newPreset,
        },
        { root: true },
      );
      commit('setPreset', newPreset);
      return newPreset;
    },
    async prefillWithSynthesisVr ({ state, dispatch, commit }, preset) {
      dispatch(
        'insertEntities',
        {
          name: 'Game',
          payload: preset,
        },
        { root: true },
      );
      commit('setPreset', preset);
      return preset;
    },
    async createGameFromSynthesisVr ({ state, dispatch }, preset) {
      const query = `
  mutation ($game: GameInput) {
    game: storeGame(game: $game) {
      id
    }
  }
`;
      const variables = {
        game: {
          title: preset.title,
          description: preset.description,
          uri: preset.uri,
          launchMethod: preset.launchMethod,
          ageRating: preset.ageRating,
          difficulty: preset.difficulty,
          licensingSource: 'other',
          imageBlobFieldName: 'image',
          videoBlobFieldName: 'video',
          imageUrl: preset.imageUrl,
          videoUrl: preset.videoUrl,
        },
      };

      const { game: newGame } = await gql.request(query, variables);
      return newGame.id;
    },
    async storeNewTagForGame ({ state, dispatch }, data) {
      const query = `
    mutation ($tag: TagInput) {
      storeTag(tag: $tag) {
        id
        text
        order
        operatorOnly
        games {
          id
        }
      }
    }
  `;

      const variables = {
        tag: {
          operatorOnly: true,
          text: data.tag,
          games: [
            {
              id: data.gameId,
            },
          ],
        },
      };
      const { storeTag: savedTag } = await gql.request(query, variables);
      return savedTag;
    },
  },
  mutations: {
    setLicensingSource (state, licensingSource) {
      state.newGame.licensingSource = licensingSource;
    },
    setPreset (state, preset) {
      state.presetId = preset.id;
    },
    updateGame (state, game) {
      Object.entries(game).forEach(([k, val]) => {
        Vue.set(state.newGame, k, val);
      });
    },
    setSynthesisVrId (state, synthesisVrId) {
      state.synthesisVrId = synthesisVrId;
    },
  },
};
